import { CountWithPercentageMetric, QueueMetrics } from 'modules/Monitoring/types'
import { formatDuration, Formats } from 'modules/Monitoring/utils/formatTimeAndDuration'
import { pluralize } from 'modules/Monitoring/utils/pluralize'

import { QueueHealthDetailFormattedData } from '../types'

type SubRowData = { name: string; id: string } & QueueMetrics

const formatTicketsCount = (data: SubRowData, unit: string) =>
  `${data.unassignedTicketCount.value} unassigned ${pluralize(
    unit,
    data.unassignedTicketCount.value,
    true,
  )} with max QWT ${formatDuration(data.maxQwt.value, {
    format: Formats.Long,
  })}`

const formatAgentCount = (metric: CountWithPercentageMetric) =>
  `${metric.value} (${metric.percentageOfTotal}%)`

const formatQueues = (unit: string, data?: SubRowData[]) =>
  data?.map(queue => `${queue.name} - ${formatTicketsCount(queue, unit)}`).join('\n') ??
  '-'

const formatChnnelSpecLabel = (isDante: boolean) => (isDante ? 'Topic' : 'Spec')

export const getSpecialisationReport = (
  data: QueueHealthDetailFormattedData,
  unit: string,
  isDante: boolean,
) => `Report template

RCA: ${new Date().toUTCString()}
Issue: {{ Manual input }}
${formatChnnelSpecLabel(isDante)}: ${data.name}
${formatTicketsCount(data, unit)}

Capacity: Scheduled - ${data.scheduledAgentCount.value}
Online - ${formatAgentCount(data.onlineAgentCount)}
Offline - ${formatAgentCount(data.offlineAgentCount)}
Absent - ${formatAgentCount(data.absentAgentCount)}
On break - ${formatAgentCount(data.onBreakAgentCount)}
Overtime - ${formatAgentCount(data.overtimeAgentCount)}

Queues breakdown:
${formatQueues(unit, data.subRows)}

Reasons: {{ Manual input }}

Actions taken: {{ Manual input }}

Outcome: {{ Manual input }}`
